import React from 'react';
import { Box, Text } from '@stitch-fix/mode-react';
import { PersonProps } from './Person/Person';
import { Person } from './Person';
import styles from './styles.module.scss';

export interface AboutPersonsProps {
  heading: string;
  persons: PersonProps[];
}

export const AboutPersons = ({ heading, persons }: AboutPersonsProps) => {
  return (
    <Box className={styles.section}>
      <Text setting="title-large">{heading}</Text>
      <Box className={styles.persons}>
        {persons.map(person => (
          <Person
            key={person.name}
            name={person.name}
            title={person.title}
            role={person.role}
            description={person.description}
            image={person.image}
          />
        ))}
      </Box>
    </Box>
  );
};
